import React, { useState } from 'react';
import './EmojiPicker.css';

const EmojiPicker = ({ onEmojiSelect, onClose }) => {
  const [activeCategory, setActiveCategory] = useState('smileys');

  const emojiCategories = {
    smileys: {
      name: 'Smileys & Emotionen',
      emojis: [
        '😀', '😃', '😄', '😁', '😆', '😅', '🤣', '😂',
        '🙂', '🙃', '😉', '😊', '😇', '🥰', '😍', '🤩',
        '😘', '😗', '😚', '😙', '😋', '😛', '😜', '🤪',
        '😝', '🤑', '🤗', '🤭', '🤫', '🤔', '🤐', '🤨',
        '😐', '😑', '😶', '😏', '😒', '🙄', '😬', '🤥',
        '😌', '😔', '😪', '🤤', '😴', '😷', '🤒', '🤕',
        '🤢', '🤮', '🤧', '🥵', '🥶', '😵', '🤯', '🤠',
        '🥳', '😎', '🤓', '🧐', '😕', '😟', '🙁', '☹️',
        '😮', '😯', '😲', '😳', '🥺', '😦', '😧', '😨',
        '😰', '😥', '😢', '😭', '😱', '😖', '😣', '😞',
        '😓', '😩', '😫', '🥱', '😤', '😡', '😠', '🤬',
        '👍', '👎', '👏', '🙌', '👐', '🤲', '🤝', '🙏'
      ]
    },
    gestures: {
      name: 'Gesten',
      emojis: [
        '👋', '🤚', '🖐', '✋', '🖖', '👌', '🤏', '✌️',
        '🤞', '🤟', '🤘', '🤙', '👈', '👉', '👆', '🖕',
        '👇', '☝️', '👍', '👎', '✊', '👊', '🤛', '🤜',
        '👏', '🙌', '👐', '🤲', '🤝', '🙏', '✍️', '💅',
        '🤳', '💪', '🦾', '🦿', '🦵', '🦶', '👂', '🦻',
        '👃', '🧠', '🦷', '🦴', '👀', '👁', '👅', '👄'
      ]
    },
    people: {
      name: 'Menschen',
      emojis: [
        '👶', '👧', '🧒', '👦', '👩', '🧑', '👨', '👵',
        '🧓', '👴', '👲', '👳', '🧕', '👮', '👷', '💂',
        '🕵', '👩‍⚕️', '👨‍⚕️', '👩‍🎓', '👨‍🎓', '👩‍🏫', '👨‍🏫', '👩‍⚖️',
        '👨‍⚖️', '👩‍🌾', '👨‍🌾', '👩‍🍳', '👨‍🍳', '👩‍🔧', '👨‍🔧', '👩‍🏭',
        '👨‍🏭', '👩‍💼', '👨‍💼', '👩‍🔬', '👨‍🔬', '👩‍💻', '👨‍💻', '👩‍🎤',
        '👨‍🎤', '👩‍🎨', '👨‍🎨', '👩‍✈️', '👨‍✈️', '👩‍🚀', '👨‍🚀', '👩‍🚒'
      ]
    },
    animals: {
      name: 'Tiere',
      emojis: [
        '🐶', '🐱', '🐭', '🐹', '🐰', '🦊', '🐻', '🐼',
        '🐨', '🐯', '🦁', '🐮', '🐷', '🐽', '🐸', '🐵',
        '🙈', '🙉', '🙊', '🐒', '🐔', '🐧', '🐦', '🐤',
        '🐣', '🐥', '🦆', '🦅', '🦉', '🦇', '🐺', '🐗',
        '🐴', '🦄', '🐝', '🐛', '🦋', '🐌', '🐞', '🐜',
        '🦟', '🦗', '🕷', '🦂', '🐢', '🐍', '🦎', '🦖'
      ]
    },
    food: {
      name: 'Essen & Trinken',
      emojis: [
        '🍏', '🍎', '🍐', '🍊', '🍋', '🍌', '🍉', '🍇',
        '🍓', '🍈', '🍒', '🍑', '🥭', '🍍', '🥥', '🥝',
        '🍅', '🍆', '🥑', '🥦', '🥬', '🥒', '🌶', '🌽',
        '🥕', '🥔', '🍠', '🥐', '🍞', '🥖', '🥨', '🥯',
        '🧀', '🥚', '🍳', '🥞', '🥓', '🥩', '🍗', '🍖',
        '🌭', '🍔', '🍟', '🍕', '🥪', '🥙', '🌮', '🌯',
        '🍜', '🍲', '🍛', '🍣', '🍱', '🥟', '🍤', '🍙',
        '☕', '🍵', '🧃', '🥤', '🍶', '🍺', '🍻', '🥂'
      ]
    },
    activities: {
      name: 'Aktivitäten',
      emojis: [
        '⚽', '🏀', '🏈', '⚾', '🥎', '🎾', '🏐', '🏉',
        '🥏', '🎱', '🏓', '🏸', '🏒', '🏑', '🥍', '🏏',
        '⛳', '🏹', '🎣', '🥊', '🥋', '🎽', '⛸', '🥌',
        '🛷', '🎿', '⛷', '🏂', '🏋️', '🤼', '🤸', '🤺',
        '🤾', '🏌️', '🏇', '🧘', '🏊', '🤽', '🚣', '🧗',
        '🚴', '🚵', '🎪', '🎭', '🎨', '🎬', '🎤', '🎧',
        '🎼', '🎹', '🥁', '🎷', '🎺', '🎸', '🎻', '🎲'
      ]
    },
    travel: {
      name: 'Reisen & Orte',
      emojis: [
        '🚗', '🚕', '🚙', '🚌', '🚎', '🏎', '🚓', '🚑',
        '🚒', '🚐', '🚚', '🚛', '🚜', '🛴', '🚲', '🛵',
        '🏍', '🚨', '🚔', '🚍', '🚘', '🚖', '🚡', '🚠',
        '🚟', '🚃', '🚋', '🚞', '🚝', '🚄', '🚅', '🚈',
        '🚂', '🚆', '🚇', '🚊', '🚉', '✈️', '🛫', '🛬',
        '🛩', '💺', '🚁', '🛰', '🚀', '🛸', '🚢', '⛵',
        '🏠', '🏡', '🏢', '🏣', '🏤', '🏥', '🏦', '🏨',
        '🏩', '🏪', '🏫', '🏬', '🏭', '🏯', '🏰', '🗼'
      ]
    },
    objects: {
      name: 'Objekte',
      emojis: [
        '⌚', '📱', '📲', '💻', '⌨️', '🖥', '🖨', '🖱',
        '🖲', '🕹', '🗜', '💽', '💾', '💿', '📀', '📼',
        '📷', '📸', '📹', '🎥', '📽', '🎞', '📞', '☎️',
        '📟', '📠', '📺', '📻', '🎙', '🎚', '🎛', '⏱',
        '⏲', '⏰', '🕰', '⌛', '⏳', '📡', '🔋', '🔌',
        '💡', '🔦', '🕯', '🗑', '🛢', '💸', '💵', '💴',
        '💶', '💷', '💰', '💳', '📧', '📨', '📩', '📤',
        '📥', '📦', '📫', '📪', '📬', '📭', '📮', '🗳'
      ]
    },
    symbols: {
      name: 'Symbole',
      emojis: [
        '❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍',
        '🤎', '💔', '❣️', '💕', '💞', '💓', '💗', '💖',
        '💘', '💝', '💟', '☮️', '✝️', '☪️', '🕉', '☸️',
        '✡️', '🔯', '🕎', '☯️', '☦️', '🛐', '⛎', '♈',
        '♉', '♊', '♋', '♌', '♍', '♎', '♏', '♐',
        '♑', '♒', '♓', '🆔', '⚛️', '🉑', '☢️', '☣️',
        '📴', '📳', '🈶', '🈚', '🈸', '🈺', '🈷️', '✴️',
        '🆚', '💮', '🉐', '㊙️', '㊗️', '🈴', '🈵', '🈹'
      ]
    }
  };

  const categories = Object.keys(emojiCategories);

  const handleEmojiClick = (emoji) => {
    onEmojiSelect(emoji);
    onClose();
  };

  return (
    <div className="emoji-picker-overlay" onClick={onClose}>
      <div className="emoji-picker" onClick={(e) => e.stopPropagation()}>
        <div className="emoji-picker-header">
          <h3>Emoji auswählen</h3>
          <button className="emoji-picker-close" onClick={onClose}>✕</button>
        </div>

        <div className="emoji-categories">
          {categories.map(category => (
            <button
              key={category}
              className={`emoji-category-btn ${activeCategory === category ? 'active' : ''}`}
              onClick={() => setActiveCategory(category)}
              title={emojiCategories[category].name}
            >
              {emojiCategories[category].emojis[0]}
            </button>
          ))}
        </div>

        <div className="emoji-grid">
          {emojiCategories[activeCategory].emojis.map((emoji, index) => (
            <button
              key={index}
              className="emoji-button"
              onClick={() => handleEmojiClick(emoji)}
              title={emoji}
            >
              {emoji}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EmojiPicker;
